import type { ContentObject } from 'models';
import { Button, Icon } from 'ui';
import { useLikeObjectMutation, useUnlikeObjectMutation } from '../queries';
import { LikeButtonContent, type LikeButtonType } from './like-button-content';

type P = {
  contentObject: ContentObject;
  type?: LikeButtonType;
};

const LikeButton = ({ contentObject, type = 'count' }: P) => {
  const { isPending: isLiking, mutate: like } = useLikeObjectMutation();
  const { isPending: isUnliking, mutate: unlike } = useUnlikeObjectMutation();

  const handleLike = (item: ContentObject) => {
    item.liked ? unlike({ contentObject: item }) : like({ contentObject: item });
  };

  return (
    <Button
      icon={contentObject.liked ? <Icon color="error" icon="heart-fill" /> : <Icon icon="heart-line" />}
      loading={isLiking || isUnliking}
      onClick={() => {
        handleLike(contentObject);
      }}
      type="link-secondary"
    >
      <LikeButtonContent contentObject={contentObject} type={type} />
    </Button>
  );
};

export default LikeButton;
